/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    TibboDataType,
    BlockType,
} from '@appblocks/codegeneration/types';

export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];
    const name = feature.getSettingValue('SETTINGID');
    const dataType = feature.getSettingValue('DATATYPE');
    let DEFAULT = feature.getSettingValue('DEFAULT');
    let min = feature.getSettingValue('MIN');
    if (min === '') min = feature.getDefault('MIN');
    let max = feature.getSettingValue('MAX');
    if (max === '') max = feature.getDefault('MAX');
    const project: ProjectConfiguration = feature.project;
    const SETTINGTYPE = feature.getSettingValue('SETTINGTYPE');
    const init = feature.getSettingValue('INITIALIZE');
    const comment = feature.getSettingValue('NAME');

    if (SETTINGTYPE === 'string') {
        DEFAULT = `"${DEFAULT}"`;
    }

    if (DEFAULT === '') {
        DEFAULT = '0';
    }

    blocks.push({
        location: 'SETTINGS_SCHEMA',
        template: `
"${name}": {
    "type": "${dataType}",
    "default": ${DEFAULT},
    "min": ${min},
    "max": ${max},
    "comment": "${comment}",
},
    `,
    });

    let targetDataType = TibboDataType.STRING;
    switch (SETTINGTYPE) {
        case 'string':
            targetDataType = TibboDataType.STRING;
            break;
        case 'float':
            targetDataType = TibboDataType.FLOAT;
            break;
        case 'datetime':
            targetDataType = TibboDataType.INTEGER;
            break;
        case 'time':
            targetDataType = TibboDataType.INTEGER;
            break;
        default:

            break;
    }

    blocks.push({
        location: 'boot_complete',
        template: `
global ${name}

${name} = ${project.convertDataType(`stg_get('${name}') or ${DEFAULT}`, TibboDataType.STRING, targetDataType)}
    `,
    });

    blocks.push({
        location: 'callback_stg_post_set',
        blockType: BlockType.CODE,
        template: `
if stg_name_or_num=="${name}":
    var_${name}_update_completed(${project.convertDataType('stg_value', TibboDataType.STRING, targetDataType)})
`,
    });

    return blocks;
};
